import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { Table, TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { ContactService } from '../../services/contact-service/contact.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { DropdownModule } from 'primeng/dropdown';
import { ProductService } from '../../pages/service/product.service';
import { SocieteServiceService } from '../../services/societe-service/societe.service';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

@Component({
    selector: 'app-gestion-contact',
    imports: [
        BreadcrumbModule,
        CommonModule,
        TableModule,
        FormsModule,
        ButtonModule,
        ToastModule,
        ToolbarModule,
        InputTextModule,
        SelectModule,
        DialogModule,
        InputIconModule,
        IconFieldModule,
        ConfirmDialogModule,
        DividerModule,
        MessageModule,
        SelectButtonModule,
        DropdownModule,
        ToggleSwitchModule
    ],
    templateUrl: './gestion-contact.component.html',
    styleUrl: './gestion-contact.component.scss',
    providers: [MessageService, ProductService, ConfirmationService]

})
export class GestionContactComponent {

    breadcrumbContact = { icon: 'pi pi-home', routerLink: '/rechercher-do' };
    breadcrumbItems = [{ label: 'Gestion Contact' }];

    @ViewChild('filter') filter!: ElementRef;


    do: any;
    nomDo!: string;
    contacts: any;
    totalRecords: number = 0;
    rowsPerPageOptions: number[] = [10]; // Valeur par défaut
    selectedContacts: any[] = [];
    loading: boolean = true;
    addContactDialog: boolean = false;
    // vaiables pour la civilité
    selectButtonValue: any = null;
    selectButtonValues: any = [{ name: 'Mr' }, { name: 'Mrs' },
    { name: 'M.' }, { name: 'Mme' }, { name: 'Mlle' },
    { name: 'Me' }, { name: 'Dr' }, { name: 'Pr' }, { name: 'Sec' }
    ];
    selectedCodeSociete: any;
    listCodeSociete: any[] = [];
    submitted: boolean = false;
    contact: any;
    detailsContactDialog: boolean = false;
    updateContactDialog: boolean = false;
    selectedcontactItem: any;
    AgentModif!: string;
    listCodeSocieteLoaded: boolean = false;
    switchValue: boolean = false;

    statusOptions = [
        { label: 'Activé', value: 1 },
        { label: 'Désactivé', value: 0 }
    ];
    isDisableMode = false;
    isEnableMode = false;
    isDisable: boolean = false;



    constructor(
        private contactService: ContactService,
        private societeService: SocieteServiceService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private router: Router,
        private cd: ChangeDetectorRef
    ) { }
    ngOnInit() {
        const savedSelection = sessionStorage.getItem('selectedDo');
        if (!savedSelection) {
            this.router.navigate(['/rechercher-do']);
        } else {
            let selectedDo = JSON.parse(savedSelection);
            this.do = selectedDo.code_interne;
            this.nomDo = selectedDo.Nom;
        }

        this.loadContactData();
        this.loadCodeSocietes();
    }

    loadContactData() {
        this.contactService.getAllContactsByCodeDo(this.do).subscribe({
            next: (data: any) => {
                this.contacts = data;
                this.totalRecords = data.length;
                this.updateRowsPerPageOptions();
                //console.log('Contacts:', this.contacts);
                this.loading = false;
            },
            error: (error) => {
                console.error('Erreur lors de la récupération des contacts:', error);
                this.messageService.add({
                    severity: 'error',
                    summary: 'Erreur',
                    detail: 'Impossible de charger les contacts.'
                });
            }
        });
    }

    // Modifiez cette méthode
    loadCodeSocietes() {
        if (this.listCodeSocieteLoaded) return; // Ne recharge pas si déjà chargé

        this.societeService.getAllSocieteByCodeDo(this.do).subscribe({
            next: (data: any) => {
                this.listCodeSociete = data.map((societe: any) => ({
                    code: societe.code_interne.toString(),
                    name: `${societe.Nom}`,
                    originalData: societe
                }));
                this.listCodeSocieteLoaded = true; // Marque comme chargé
            },
            error: (error) => {
                console.error('Erreur lors de la récupération des sociétés:', error);
            }
        });
    }


    updateRowsPerPageOptions() {
        const baseOptions = [10, 20, 30, 40, 50];

        // Limitez les options supplémentaires à des valeurs raisonnables
        const maxReasonableOption = 100; // Définissez une limite supérieure raisonnable

        if (this.totalRecords > 50) {
            const additionalOptions = [];
            // Ajoutez des options jusqu'à la limite raisonnable ou au totalRecords (le plus petit des deux)
            const upperLimit = Math.min(this.totalRecords, maxReasonableOption);

            for (let i = 100; i <= upperLimit; i += 100) {
                additionalOptions.push(i);
            }

            this.rowsPerPageOptions = [...baseOptions, ...additionalOptions];
        } else {
            this.rowsPerPageOptions = baseOptions;
        }

        // Ajoutez le totalRecords seulement s'il est raisonnable et différent des options existantes
        if (this.totalRecords <= maxReasonableOption &&
            !this.rowsPerPageOptions.includes(this.totalRecords)) {
            this.rowsPerPageOptions.push(this.totalRecords);
        }
    }

    clear(table: Table) {
        table.clear();
        this.filter.nativeElement.value = '';
    }

    onGlobalFilter(table: Table, event: Event) {
        table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
    }

    openDetailsContact(selectedcontactItem: any) {
        this.selectedcontactItem = selectedcontactItem;
        this.detailsContactDialog = true;
    }

    // Méthode pour ouvrir le dialogue
    openNewContact() {
        this.submitted = false;
        this.contact = {};
        this.selectedCodeSociete = null;
        this.selectButtonValue = null;
        // Si les sociétés ne sont pas encore chargées, affichez un loader
        // if (this.listCodeSociete.length === 0) {
        //     this.messageService.add({
        //         severity: 'info',
        //         summary: 'Chargement',
        //         detail: 'Chargement des sociétés en cours...',
        //         life: 2000
        //     });
        // }

        this.addContactDialog = true;

    }

    // Méthode pour valider l'email
    isValidEmail(email: string): boolean {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }
    hideDialog() {
        this.addContactDialog = false;
        this.detailsContactDialog = false;
        this.updateContactDialog = false;
        this.submitted = false;
    }
    validateAndSaveContact() {
        this.submitted = true;

        if (!this.isFormValid()) {
            if (this.contact.AdrEmail && !this.isValidEmail(this.contact.AdrEmail)) {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Erreur',
                    detail: 'Veuillez entrer une adresse email valide',
                    life: 3000
                });
            }
            this.isDisable = false;
            return;
        }

        this.addContact();
        this.isDisable = true;
    }

    // Méthode pour vérifier la validité du formulaire
    isFormValid(): boolean {
        const requiredFieldsValid = this.selectedCodeSociete &&
            this.selectButtonValue &&
            this.contact.Nom &&
            this.contact.Tel1

        // Vérification optionnelle de l'email si fourni
        const emailValid = !this.contact.AdrEmail || this.isValidEmail(this.contact.AdrEmail);

        this.isDisable = false;
        return requiredFieldsValid && emailValid;

    }

    addContact() {

        const userData = localStorage.getItem('currentUser') || '';

        let user = JSON.parse(userData);
        let agentName = user.name;


        // Préparer l'objet contact à envoyer
        const contact = {
            code_Societe: this.selectedCodeSociete.code,
            Civilite: this.selectButtonValue.name,
            Nom: this.contact.Nom,
            Prenom: this.contact.Prenom,
            Adresse: this.contact.Adresse,
            Ville: this.contact.Ville,
            Code_Postal: this.contact.Code_Postal,
            Tel1: this.contact.Tel1,
            Tel2: this.contact.Tel2,
            Tel3: this.contact.Tel3,
            Fax: this.contact.Fax,
            AdrEmail: this.contact.AdrEmail,
            Fonction: this.contact.Fonction,
            Service: this.contact.Service,
            AgentModif: agentName
        };
        //console.log("Payload contact", contact);

        // Appel au service pour sauvegarder
        this.contactService.addContact(contact).subscribe({
            next: () => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Succès',
                    detail: 'Contact enregistré avec succès',
                    life: 3000
                });
                this.isDisable = false;
                this.hideDialog();
                this.loadContactData();
            },
            error: (error) => {
                console.error('Erreur:', error);
                this.messageService.add({
                    severity: 'error',
                    summary: 'Erreur',
                    detail: 'Échec de l\'enregistrement du contact',
                    life: 3000
                });
                this.isDisable = false;
            }
        });

    }


    disableSelectedContacts() {
        this.confirmationService.confirm({
            message: 'Souhaitez-vous vraiment désactiver les contacts ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            rejectButtonStyleClass: 'p-button-secondary',
            acceptLabel: 'Oui',
            rejectLabel: 'Non',
            accept: () => {
                console.log('Bouton cliqué - selected:', this.selectedContacts);
                if (!this.selectedContacts || this.selectedContacts.length === 0) {
                    this.messageService.add({
                        severity: 'warn',
                        summary: 'Avertissement',
                        detail: 'Aucune contact sélectionnée',
                        life: 3000
                    });
                    return;
                }

                // Marquer les contacts comme en cours de traitement
                this.selectedContacts.forEach(contact => {
                    contact.toggleLoading = true;
                });

                const codes = this.selectedContacts.map(a => a.code_interne);
                this.contactService.disableOneOrManyContacts(codes).subscribe({
                    next: () => {
                        // Mettre à jour localement sans recharger
                        this.selectedContacts.forEach(contact => {
                            contact.FlagActif = 0; // 0 pour désactivé
                            contact.toggleLoading = false; 
                        });

                        this.isDisableMode = true;
                        // Vider la sélection
                        this.selectedContacts = [];
                        this.cd.detectChanges();

                        // Afficher le message de succès
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Succès',
                            detail: `${codes.length} contacts(s) désactivée(s)`,
                            life: 3000
                        });
                    },
                    error: (error) => {
                        console.error('Erreur lors de la désactivation:', error);
                        // Réinitialiser l'état de chargement en cas d'erreur
                        this.selectedContacts.forEach(contact => {
                            contact.toggleLoading = false;
                        });
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Erreur',
                            detail: 'Une erreur est survenue lors de la désactivation',
                            life: 3000
                        });
                    }
                });
            }
        });
    }

    enableSelectedContacts() {
        this.confirmationService.confirm({
            message: 'Souhaitez-vous vraiment activer les contacts ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            rejectButtonStyleClass: 'p-button-secondary',
            acceptLabel: 'Oui',
            rejectLabel: 'Non',
            accept: () => {
                console.log('Bouton cliqué - selected:', this.selectedContacts);
                if (!this.selectedContacts || this.selectedContacts.length === 0) {
                    this.messageService.add({
                        severity: 'warn',
                        summary: 'Avertissement',
                        detail: 'Aucune contact sélectionnée',
                        life: 3000
                    });
                    return;
                }
                // Marquer les contacts comme en cours de traitement
                this.selectedContacts.forEach(contact => {
                    contact.toggleLoading = true;
                });

                const codes = this.selectedContacts.map(a => a.code_interne);
                this.contactService.enableOneOrManyContacts(codes).subscribe({
                    next: () => {
                        // Mettre à jour localement sans recharger
                        this.selectedContacts.forEach(contact => {
                            contact.FlagActif = 1; // 1 pour activé
                            contact.toggleLoading = false;
                        });

                        this.isEnableMode = true;
                        // Vider la sélection
                        this.selectedContacts = [];
                        this.cd.detectChanges();

                        // Afficher le message de succès
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Succès',
                            detail: `${codes.length} contacts(s) activée(s)`,
                            life: 3000
                        });
                    },
                    error: (error) => {
                        // Réinitialiser l'état de chargement en cas d'erreur
                        this.selectedContacts.forEach(contact => {
                            contact.toggleLoading = false;
                        });
                        console.error('Erreur lors de l\'activation', error);
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Erreur',
                            detail: 'Une erreur est survenue lors de l\'activation',
                            life: 3000
                        });
                    }
                });
            }
        });
    }

    shouldDisableHeaderCheckbox(): boolean {
        if (this.isDisableMode) {
            return this.contacts.every((c:any) => c.FlagActif === 0);
        } else if (this.isEnableMode) {
            return this.contacts.every((c:any) => c.FlagActif === 1);
        }
        return false;
        }

    // deleteByContact(contact: any) {
    //     this.confirmationService.confirm({
    //         message: 'Souhaitez-vous vraiment supprimer ' + contact.Nom + ' ' + contact.Prenom + '?',
    //         header: 'Confirmer',
    //         icon: 'pi pi-exclamation-triangle',
    //         rejectButtonStyleClass: 'p-button-secondary',
    //         acceptLabel: 'Oui',
    //         rejectLabel: 'Non',
    //         accept: () => {
    //             this.contactService.disableOneOrManyContacts([contact.code_interne]).subscribe(
    //                 (result: any) => {
    //                     console.warn(result);
    //                     this.loadContactData();

    //                     this.messageService.add({
    //                         severity: 'success',
    //                         summary: 'Succès',
    //                         detail: 'Contact supprimé avec succès',
    //                         life: 3000,

    //                     });
    //                 },
    //                 (error) => {
    //                     console.log(error);
    //                     this.messageService.add({
    //                         severity: 'error',
    //                         summary: 'Erreur',
    //                         detail: 'Échec de la suppression de contact' + contact.Nom + ' ' + contact.Prenom,
    //                         life: 3000
    //                     });
    //                 }
    //             )

    //         }
    //     });
    // }

    async openUpdateContact(contactModified: any) {
        this.submitted = false;
        this.selectedcontactItem = contactModified;
        this.contact = { ...contactModified };
        this.selectButtonValue = this.selectButtonValues.find((item: any) => item.name === contactModified.Civilite);

        // Si les sociétés ne sont pas encore chargées, affichez un loader
        if (this.listCodeSociete.length === 0) {
            this.messageService.add({
                severity: 'info',
                summary: 'Chargement',
                detail: 'Chargement des sociétés en cours...',
                life: 2000
            });
        }

        this.selectedCodeSociete = this.listCodeSociete.find((item: any) =>
            item.code === contactModified.code_Societe.toString()
        );
        this.updateContactDialog = true;

    }

    validateAndUpdateContact(code_interne: number) {
        this.submitted = true;

        if (!this.isFormValid()) {
            if (this.contact.AdrEmail && !this.isValidEmail(this.contact.AdrEmail)) {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Erreur',
                    detail: 'Veuillez entrer une adresse email valide',
                    life: 3000
                });
            }
            this.isDisable = false;
            return;
        }

        this.updateContact(code_interne);
        this.isDisable = true;
    }

    updateContact(code_interne: number) {
        const userData = localStorage.getItem('currentUser') || '';
        let user = JSON.parse(userData);
        let agentName = user.name;

        // Préparer l'objet contact à envoyer
        const contact = {
            code_Societe: this.selectedCodeSociete.code,
            Civilite: this.selectButtonValue.name,
            Nom: this.contact.Nom,
            Prenom: this.contact.Prenom,
            Adresse: this.contact.Adresse,
            Ville: this.contact.Ville,
            Code_Postal: this.contact.Code_Postal,
            Tel1: this.contact.Tel1,
            Tel2: this.contact.Tel2,
            Tel3: this.contact.Tel3,
            Fax: this.contact.Fax,
            AdrEmail: this.contact.AdrEmail,
            Fonction: this.contact.Fonction,
            Service: this.contact.Service,
            AgentModif: agentName
        };

        //console.log("Payload contact update", contact);

        // Appel au service pour mettre à jour
        this.contactService.updateContact(code_interne, contact).subscribe({
            next: () => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Succès',
                    detail: 'Contact modifié avec succès',
                    life: 3000
                });
                this.isDisable = false;
                this.hideDialog();
                this.loadContactData();
            },
            error: (error) => {
                console.error('Erreur:', error);
                this.messageService.add({
                    severity: 'error',
                    summary: 'Erreur',
                    detail: 'Échec de la modification du contact',
                    life: 3000
                });
                this.isDisable = false;
            }
        });
    }

    // Méthode pour activer/désactiver un contact via le toggle
    onToggleChange(contact: any) {
        // Sauvegarder l'état original pour le revert en cas d'erreur
        const originalState = contact.FlagActif;
        // Désactiver le toggle pendant la requête
        contact.toggleLoading = true;
        // Déterminer l'action à effectuer
        const newState = originalState === 1 ? 0 : 1;

        const code_interne = [contact.code_interne];
        const serviceCall = newState === 1
            ? this.contactService.disableOneOrManyContacts(code_interne)
            : this.contactService.enableOneOrManyContacts(code_interne);

        serviceCall.subscribe({
            next: () => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Succès',
                    detail: `Contact ${newState === 1 ? 'désactivé' : 'activé'} avec succès`,
                    life: 3000
                });
                this.cd.detectChanges();
            },
            error: (error) => {
                // Revenir à l'état original en cas d'erreur
                contact.FlagActif = originalState;
                contact.toggleLoading = false; // Réactiver le toggle
                console.error('Erreur:', error);
                this.messageService.add({
                    severity: 'error',
                    summary: 'Erreur',
                    detail: `Échec de ${newState === 1 ? 'la désactivation' : 'l\'activation'} du contact`,
                    life: 3000
                });
            },
            complete: () => {
                contact.toggleLoading = false;
                this.cd.detectChanges();
            }
        });
    }

    // Méthode pour vérifier si tous les contacts sélectionnés sont activés
    allSelectedContactsActive(): boolean {
        return this.selectedContacts && this.selectedContacts.length > 0 && 
            this.selectedContacts.every(contact => contact.FlagActif === 1);
    }

    // Méthode pour vérifier si tous les contacts sélectionnés sont désactivés
    allSelectedContactsInactive(): boolean {
        return this.selectedContacts && this.selectedContacts.length > 0 && 
            this.selectedContacts.every(contact => contact.FlagActif === 0);
    }

    // Méthode pour vérifier si la sélection est mixte (actifs et inactifs)
   hasMixedSelection(): boolean {
    if (!this.selectedContacts || this.selectedContacts.length === 0) return false;
    const hasActive = this.selectedContacts.some(contact => contact.FlagActif === 1);
    const hasInactive = this.selectedContacts.some(contact => contact.FlagActif === 0);
    return hasActive && hasInactive;
}

}
